export default class MiscTools {
  sleep(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms))
  }

  getSample<T>(arr: T[], n: number): T[] {
    let result = new Array(n)
    let len = arr.length
    let taken = new Array(len)
    if (n > len)
      throw new RangeError('getRandom: more elements taken than available')
    while (n--) {
      let x = Math.floor(Math.random() * len)
      result[n] = arr[x in taken ? taken[x] : x]
      taken[x] = --len in taken ? taken[len] : len
    }
    return result
  }

  /**
   * Create a range of numbers as an array
   * @param start
   * @param end
   * @returns {number[]}
   */
  range(start: number, end: number): number[] {
    let list: number[] = []
    for (let i = start; i <= end; i++) {
      list.push(i)
    }
    return list
  }

  /**
   * Check if an object is empty
   * @param obj
   * @returns {boolean}
   */
  isEmpty(obj: object | null | undefined): boolean {
    if (obj === null || obj === undefined) {
      return true
    }

    if (Array.isArray(obj)) {
      return obj.length === 0
    }

    if (typeof obj === 'object') {
      return Object.keys(obj).length === 0
    }

    return false
  }

  /**
   * Get the intersection of two arrays
   * @param arrays
   * @returns {T[]}
   */
  intersection<T>(arrays: T[][]): T[] {
    return arrays.reduce((a, b) => a.filter((c) => b.includes(c)))
  }

  /**
   * Get a random number in a range
   * @param min
   * @param max
   * @returns {number}
   */
  randomInRange(min: number, max: number): number {
    let randomNum = Math.random() * (max - min) + min
    return Math.floor(randomNum)
  }
}
